module.exports = __webpack_public_path__ + "static/media/uber-logo.f2899ceb.svg";